/**
 * useCurrentWorkspace.ts -- TDD stub. Will be fully implemented by T330.
 *
 * This file exists to allow T329 red-phase tests to resolve mocks.
 */

export interface WorkspaceData {
  name: string;
  slug: string;
}

export interface UseCurrentWorkspaceResult {
  status: "loading" | "ready" | "empty" | "error" | "forbidden";
  data?: WorkspaceData;
}

export function useCurrentWorkspace(): UseCurrentWorkspaceResult {
  return { status: "loading" };
}
